import type { LucideIcon } from 'lucide-react';
import {
  BarChart3,
  Briefcase,
  Camera,
  Code2,
  Compass,
  Facebook,
  Github,
  Globe2,
  Instagram,
  Lightbulb,
  Link2,
  Linkedin,
  MapPin,
  Mail,
  MessageCircle,
  Music2,
  Palette,
  PenTool,
  Radio,
  Rocket,
  Search,
  Send,
  Smartphone,
  Target,
  Youtube
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  BarChart3,
  Briefcase,
  Camera,
  Code2,
  Compass,
  Facebook,
  Github,
  Globe2,
  Instagram,
  Lightbulb,
  Link2,
  Linkedin,
  MapPin,
  Mail,
  MessageCircle,
  Music2,
  Palette,
  PenTool,
  Radio,
  Rocket,
  Search,
  Send,
  Smartphone,
  Target,
  Youtube
};

export function getIcon(name: string): LucideIcon {
  return iconMap[name] ?? Globe2;
}
